export const CardPriorities = {
    PRIMARY: 'PRIMARY',
    BACKUP: 'BACKUP',
} as const;

export type CardPriority = (typeof CardPriorities)[keyof typeof CardPriorities] | string;
